import React from "react";

type Props = {};

const GuideTool = (props: Props) => {
  return <div className="card-hover h-full w-full min-h-44">GuideTool</div>;
};

export default GuideTool;
